// In-memory cache of the current device's Expo push token, so sign-out can
// delete the server row without touching native APIs (which may prompt or
// fail after the session is gone).
let cachedPushToken: string | null = null;

export function setCachedPushToken(token: string | null) {
  cachedPushToken = token;
}

export function getCachedPushToken(): string | null {
  return cachedPushToken;
}
